export const environment = {
  production: false,
  existingCaseWorthyAPIURL: "https://sb.cw.caseworthy.net/CaseWorthy.API/",
  nextGenAccountsAPIURL: "https://sb.api.cwe.cw.caseworthy.net/account/services/v1/",
  nextGenFormsAPIURL: "https://sb.api.cwe.cw.caseworthy.net/forms/services/v1/",
  nextGenQueryAPIURL: "https://sb.api.cwe.cw.caseworthy.net/query-apbuilder/services/v1/",
  nextGenServerUrl: "https://sb.api.cwe.cw.caseworthy.net/",
};
